// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statisticWrapper__dtH7q {
  display: flex;
  flex-direction: column;
  flex: 0 0 calc(50% - 15px);
  min-width: 400px;
  background: var(--tables-primary-row-surface-default);
  box-shadow: 0px 3px 8px -1px rgba(50, 50, 71, 0.0509803922), 0px 0px 1px 0px rgba(12, 26, 75, 0.2392156863);
}
@media (max-width: 1440px) {
  .statisticWrapper__dtH7q {
    flex: 0 0 100%;
  }
}

.statisticHead__lvuxA {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  min-height: 75px;
}

.statisticHeadText__IK3Lh {
  font-weight: 500;
  font-size: 14px;
  color: var(--legend-for-header-text);
  text-transform: uppercase;
}

.statisticBody__gRYsn {
  padding: 25px;
  height: 100%;
  text-align: center;
}
.statisticBody__gRYsn .highcharts-background {
  fill: var(--tables-primary-row-surface-default);
}
.statisticBody__gRYsn .highcharts-series-group path {
  stroke: unset;
}

.statisticFooter__qpvui {
  display: flex;
  justify-content: flex-end;
  padding: 20px 25px;
  border-top: 1px solid var(--tables-primary-row-stroke);
  column-gap: 16px;
  font-size: 12px;
}

.link__b83j8 {
  display: flex;
  align-items: center;
  column-gap: 16px;
  color: var(--buttons-surface);
  cursor: pointer;
  text-decoration: none;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  text-transform: uppercase;
  display: flex;
}
.link__b83j8 path {
  stroke: var(--buttons-surface);
}

@media print {
  .statisticWrapper__dtH7q {
    box-shadow: unset;
    height: 100vh;
  }
  .statisticWrapper__dtH7q:first-child {
    height: calc(100vh - 80px);
  }
  .statisticBody__gRYsn {
    padding: unset;
    padding-top: 25px;
  }
  .statisticFooter__qpvui {
    display: none;
    border-top: unset;
  }
  .printHighchartsChart {
    overflow: visible !important;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/ExecutiveSummary/components/StatisticWrapper/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,gBAAA;EACA,qDAAA;EACA,2GACE;AA1EJ;AA6EE;EAVF;IAWI,cAAA;EA1EF;AACF;;AA6EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,yDAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,gBAAA;EACA,eAAA;EACA,oCAAA;EACA,yBAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AA1EF;AA6EI;EACE,+CAAA;AA3EN;AA8EM;EACE,aAAA;AA5ER;;AAkFA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sDAAA;EACA,gBAAA;EACA,eAAA;AA/EF;;AAkFA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;AA/EF;AAiFE;EACE,8BAAA;AA/EJ;;AAmFA;EACE;IACE,iBAAA;IACA,aAAA;EAhFF;EAiFE;IACE,0BAAA;EA/EJ;EAmFA;IACE,cAAA;IACA,iBAAA;EAjFF;EAoFA;IACE,aAAA;IACA,iBAAA;EAlFF;EAsFE;IACE,4BAAA;EApFJ;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.statisticWrapper {\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 calc(50% - 15px);\n  min-width: 400px;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow:\n    0px 3px 8px -1px #3232470d,\n    0px 0px 1px 0px #0c1a4b3d;\n\n  @media (max-width: 1440px) {\n    flex: 0 0 100%;\n  }\n}\n\n.statisticHead {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 25px;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  min-height: 75px;\n}\n\n.statisticHeadText {\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--legend-for-header-text);\n  text-transform: uppercase;\n}\n\n.statisticBody {\n  padding: 25px;\n  height: 100%;\n  text-align: center;\n\n  :global {\n    .highcharts-background {\n      fill: var(--tables-primary-row-surface-default);\n    }\n    .highcharts-series-group {\n      path {\n        stroke: unset;\n      }\n    }\n  }\n}\n\n.statisticFooter {\n  display: flex;\n  justify-content: flex-end;\n  padding: 20px 25px;\n  border-top: 1px solid var(--tables-primary-row-stroke);\n  column-gap: 16px;\n  font-size: 12px;\n}\n\n.link {\n  display: flex;\n  align-items: center;\n  column-gap: 16px;\n  color: var(--buttons-surface);\n  cursor: pointer;\n  text-decoration: none;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  text-transform: uppercase;\n  display: flex;\n\n  path {\n    stroke: var(--buttons-surface);\n  }\n}\n\n@media print {\n  .statisticWrapper {\n    box-shadow: unset;\n    height: 100vh;\n    &:first-child {\n      height: calc(100vh - 80px);\n    }\n  }\n\n  .statisticBody {\n    padding: unset;\n    padding-top: 25px;\n  }\n\n  .statisticFooter {\n    display: none;\n    border-top: unset;\n  }\n\n  :global {\n    .printHighchartsChart {\n      overflow: visible !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statisticWrapper": `statisticWrapper__dtH7q`,
	"statisticHead": `statisticHead__lvuxA`,
	"statisticHeadText": `statisticHeadText__IK3Lh`,
	"statisticBody": `statisticBody__gRYsn`,
	"statisticFooter": `statisticFooter__qpvui`,
	"link": `link__b83j8`
};
module.exports = ___CSS_LOADER_EXPORT___;
